export const gold = '#FFB71B';
export const silver = '#838386';
export const bronze = '#C6674A';

const categoriesColors = {
  gold,
  silver,
  bronze,
};

export const changeCategoryColor = (categoryType) =>
  categoriesColors[categoryType] || silver;

export const ringPercentage = (points) => {
  if (points < 10000) return (100 * points) / 10000;
  else if (points >= 10000 && points < 20000) return (100 * points) / 20000;
  else return 100;
};
